import {
	AccountWithWalletsAndPermissions,
	CountResponse,
	createDeleteAccountMutation,
} from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type DeleteAccountModel = ConfirmModalModel<
	AccountWithWalletsAndPermissions,
	number,
	CountResponse
>;

export const createDeleteAccountModel = (): DeleteAccountModel => {
	const deleteAccountMutation = createDeleteAccountMutation();

	const model = createConfirmModalModel<AccountWithWalletsAndPermissions, number, CountResponse>({
		modalData: declareModalData<AccountWithWalletsAndPermissions>(),
		mapModalData: ({ id }) => id,
		mutation: deleteAccountMutation,
		successMessageKey: 'delete-account.success',
	});

	return model;
};
